import React, { useRef, useState } from "react";
import "./index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import UserAddedCIP from "../components/AddCIPAndShutdown";
import { useTranslation } from "react-i18next";
import TrainSelector from "../components/TrainSelector";
import PlantInformation from "../pages/plantsPage/plantInformation";
import CostInformation from "../pages/costInformation";
import DefaultCIPInformation from "../pages/defaultCIPInformation";
import { DEFAULT_CIP_KEYS } from "../constants/global.constants";
import IdentifyCIP from "../pages/home/identifyCIP";
import { useSelector, useDispatch } from "react-redux";
import Settings from "../pages/home/Settings";
import HistoricalCIPEffectivness from "../pages/historialCIPsEffectivness";
import FoulingIdentification from "../pages/foulingIdentification";
import PredictCIP from "../pages/predict";
import { getDuplicateItems } from "../utils/Utils";
import { storeFoulingType } from "../Store/TemplateStore/template.action";
import { getfoulingType } from "../network/cipAPI";

const XLSFileUpload = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    activeStep,
    setActiveStep,
    isFirstTimeLoad,
    isBackClicked,
    setDisableNextButton,
    setSettingsButton,
  } = props;
  const { file_id, cips } = useSelector((state) => ({
    file_id: state.file_id,
    cips: state.cips,
  }));
  const [duplicateCip, setDuplicateCip] = useState(false);
  const [noCostError, setNoCostError] = useState(true);

  const fileRef = useRef(null);
  const plantRef = useRef(null);
  const defaultInfo = useRef(null);
  const settingsRef = useRef(null);

  const onNextClicked = async () => {
    if (activeStep === 1) {
      const response = await getfoulingType();
      if (response && response.data) dispatch(storeFoulingType(response.data));
      const cipCopy = { ...cips };
      const cipsStartDate = Object.values(cipCopy).map(
        (item) => item.start_date,
      );
      const duplicateCips = getDuplicateItems(cipsStartDate);
      setDuplicateCip(duplicateCips);
      if (duplicateCips.length <= 0) {
        setActiveStep(activeStep + 1);
      }
    } else if (noCostError) {
      if (settingsRef && settingsRef.current) {
        settingsRef.current.settingsInformation();
      }
      if (fileRef && fileRef.current) {
        fileRef.current.performanceData();
      }
      if (plantRef && plantRef.current) {
        plantRef.current.plantInformation();
      }
    }
  };

  React.useImperativeHandle(ref, () => ({ onNextClicked }));

  return (
    <div>
      <div className="flex-jc-center">
        <TrainSelector disabled={activeStep !== 0} />
      </div>
      {activeStep === 0 && (
        <div className="uploadContainer">
          <div className="descriptionText">
            {t("plantInformationStrings.description")}
          </div>
          <PlantInformation
            ref={plantRef}
            setActiveStep={setActiveStep}
            mandatoryThresholdFilled={true}
          />
          <Settings
            ref={settingsRef}
            fileId={file_id}
            isBackClicked={isBackClicked}
            disabled={true}
          />
          <CostInformation disabled />
          <DefaultCIPInformation
            defaultCIPKeys={DEFAULT_CIP_KEYS}
            disabled
            ref={defaultInfo}
            setActiveStep={setActiveStep}
          />
          <UserAddedCIP isFirstTimeLoad={isFirstTimeLoad} />
        </div>
      )}
      {activeStep === 1 && (
        <IdentifyCIP
          duplicateCip={duplicateCip}
          setDuplicateCip={setDuplicateCip}
          activeStep={activeStep}
          setSettingsButton={setSettingsButton}
        />
      )}
      {activeStep === 2 && (
        <HistoricalCIPEffectivness
          activeStep={activeStep}
          setSettingsButton={setSettingsButton}
          setDisableNextButton={setDisableNextButton}
        />
      )}
      {activeStep === 3 && <FoulingIdentification activeStep={activeStep} />}
      {activeStep === 4 && (
        <PredictCIP
          setDisableNextButton={setDisableNextButton}
          setSettingsButton={setSettingsButton}
        />
      )}
    </div>
  );
});

export default XLSFileUpload;
